import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import bgB3 from "../assets/bg_b3.webp";

export default function SuccessCaseB3({ videoId = "SbO4hSUZeFQ" }) {
  const { t } = useTranslation();

  return (
    <Box component="section" sx={{ bgcolor: "#454545" }}>
      <Box
        sx={{
          width: { xs: "100%", lg: "1440px" },
          mx: "auto",
          minHeight: { lg: "532.88px" },
          backgroundImage: `url(${bgB3})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background: {
              xs: "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.45) 60%, rgba(0,0,0,0.35) 100%)",
              lg: "linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 35%, rgba(0,0,0,0.2) 100%)",
            },
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            width: { xs: "100%", lg: "1248px" },
            mx: "auto",
            px: { xs: 2, sm: 3 },
            py: { xs: 5, md: 6, lg: 0 },
            display: "flex",
            alignItems: "center",
            minHeight: { lg: "532.88px" },
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: { xs: "1fr", lg: "606px 606px" },
              columnGap: { lg: "36px" },
              rowGap: { xs: 3, lg: 0 },
              alignItems: "center",
              "& > *": { maxWidth: { xs: 358, sm: 720, lg: "unset" }, mx: { xs: "auto", lg: 0 } },
            }}
          >
            {/* TEXTO */}
            <Box sx={{ maxWidth: { lg: "606px" } }}>
              <Typography
                component="h3"
                sx={{
                  fontSize: { xs: 26, md: 36, lg: 44 },
                  fontWeight: 500,
                  lineHeight: { xs: 1.12, lg: 1.15 },
                  color: "#00FF4F",
                  mb: { xs: 2, md: 3 },
                  letterSpacing: 0.5,
                }}
              >
                <Trans
                  i18nKey="casesHero.title"
                  components={{
                    bold: <Box key="bold" component="span" sx={{ fontWeight: 650 }} />,
                  }}
                  defaults={
                    'Revolucionando a <bold>produção de conteúdo</bold> com uma solução Benext'
                  }
                />
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: 15.5, md: 17, lg: 18 },
                  lineHeight: 1.6,
                  color: "#CCCCCC",
                  fontWeight: 500,
                  letterSpacing: 0.5,
                }}
              >
                <Trans
                  i18nKey="casesHero.body"
                  components={{
                    bold: <Box key="bold" component="span" sx={{ fontWeight: 650 }} />,
                    br1: <br key="br1" />,
                    br2: <br key="br2" />,
                  }}
                  defaults={
                    'Revolucionamos a produção do "Minuto B3" com IA generativa, transformando 8 horas de trabalho e 8 colaboradores em 40 minutos com apenas 1 colaborador.<br/><br/>Essa inovação resultou em <bold>70% de economia</bold> e foi reconhecida com o Prêmio Jatobá 2024.'
                  }
                />
              </Typography>
            </Box>

            <Box
              sx={{
                width: { xs: "100%", lg: "606px" },
                height: { lg: "340.88px" },
                aspectRatio: { xs: "16 / 9", lg: "auto" },
                position: "relative",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 3,
                mt: { xs: 2, lg: 0 },
                maxWidth: { xs: 358, sm: 720, lg: "unset" },
                mx: { xs: "auto", lg: 0 },
                backgroundColor: "#000",
              }}
            >
              <Box
                component="iframe"
                title={t("casesHero.videoTitle", { defaultValue: "Case Minuto B3 — Vídeo" })}
                src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                sx={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                  display: "block",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}